import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import LinearProgress from '@material-ui/core/LinearProgress';

import OrganizationMembersActions from './OrganizationMembersActions';
import OrganizationInvitationList from './OrganizationInvitationList';
import OrganizationMemberList from './OrganizationMemberList';
import AppDialog from '../appDialog/AppDialog';

import * as organizationMembersSelectors from '../../selectors/organizationMembersSelectors';
import * as userSearchSelectors from '../../selectors/userSearchSelectors';
import * as organizationInvitationSelector from '../../selectors/organizationInvitationsSelector';

const OrganizationMembers = ({
    isAddMember,
    searchTerm,
    isLoadingMembers,
    isLoadingInvitations,
    classes,
}) => {
    const renderInvitationList = !isAddMember && !searchTerm;
    const renderMemberList = !isAddMember;
    const showLoader = isLoadingMembers || isLoadingInvitations;

    return (
        <div className={classes.wrapper}>
            <OrganizationMembersActions />
            {showLoader && <LinearProgress className={classes.loader} />}
            <div className={classes.list}>
                <AppDialog />
                {renderMemberList && <OrganizationMemberList />}
                {renderInvitationList && <OrganizationInvitationList />}
            </div>
        </div>
    );
};

OrganizationMembers.propTypes = {
    isAddMember: PropTypes.bool.isRequired,
    searchTerm: PropTypes.string,
};

OrganizationMembers.defaultProps = {
    searchTerm: '',
};

const mapStateToProps = state => ({
    isLoadingMembers: organizationMembersSelectors.getIsLoadingMembers(state),
    isLoadingInvitations: organizationInvitationSelector.getIsLoadingInvitations(
        state,
    ),
    isAddMember: userSearchSelectors.isAddMember(state),
    searchTerm: organizationMembersSelectors.getOrganizationMembersSearchTerm(
        state,
    ),
});

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: spacing.maxWidth,
    },
    loader: {
        width: '100%',
        maxWidth: spacing.maxWidth,
    },
});

export default connect(mapStateToProps)(
    injectSheet(style)(OrganizationMembers),
);



// WEBPACK FOOTER //
// ./src/containers/organizationMembers/OrganizationMembers.js